import graphql from '@/graphql';
import graphqlHelper from '@/services/graphqlHelper';

const getAPIVersion = async ({ commit }) => {
  const { data } = await graphqlHelper({
    query: graphql.version.queries.get,
    variables: {},
  });
  const apiVersion = data.getHealth.version;
  commit('GET_API_VERSION', { apiVersion });
};

const displayErrorMessage = async ({ commit }, { title, message }) => {
  commit('SET_MESSAGE_ERROR', { title, message });
};

const displaySuccessMessage = async ({ commit }, { title, message }) => {
  commit('SET_MESSAGE_SUCCESS', { title, message });
};

const displayModalMessage = async ({ commit }, { title, message }) => {
  commit('SET_MESSAGE_MODAL', { title, message });
};

const setAdminSelectedOffice = async ({ commit }, { office }) => {
  commit('SET_ADMIN_SELECTED_OFFICE', { office });
};

const setAdminSelectedCompany = async ({ commit }, { company }) => {
  commit('SET_ADMIN_SELECTED_COMPANY', { company });
};

export default {
  displayErrorMessage,
  displaySuccessMessage,
  displayModalMessage,
  setAdminSelectedOffice,
  setAdminSelectedCompany,
  getAPIVersion,
};



// WEBPACK FOOTER //
// ./store/modules/global/actions.js